import { Card, CardContent, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
// import folder from "../../assets/img/folder-gray.png";
import { Skeleton } from "@mui/lab/node";

const FolderLoader = () => {
  const [itemCount, setItemCount] = useState(0);

  useEffect(() => {
    const calculateItemCount = () => {
      const screenWidth = window.innerWidth;
      // Adjust the divisor value to control the size of each item
      const count = Math.floor(screenWidth / 150);
      setItemCount(count);
    };

    calculateItemCount();
    window.addEventListener("resize", calculateItemCount);

    return () => window.removeEventListener("resize", calculateItemCount);
  }, []);

  return (
    <Stack
      width={1}
      direction="row"
      gap={2}
      padding={2}
      flexWrap="wrap"
      justifyContent="space-between"
    >
      {Array.from({ length: itemCount - 2 }, (_, i) => (
        <Card key={i} variant="outlined" sx={{ borderRadius: 2, backgroundColor: "inherit" }} hover>
          <CardContent>
            <Stack>
              <Skeleton variant="rectangular" width={95} height={75} />
              <Typography variant="caption" textAlign="center" fontSize={14} fontWeight={800}>
                <Typography variant="span">
                  <Skeleton />
                </Typography>
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      ))}
    </Stack>
  );
};

export default FolderLoader;
